import React from 'react';
import { FlatList as NativeList } from 'react-native';
import { ListItem as KListItem } from '@ui-kitten/components';
export const Native = NativeList;
export const Kitten = (props) => {
    const { ...rest } = props;
    return (<KListItem {...rest}/>);
};
export default {
    Native,
    Kitten,
};
//# sourceMappingURL=ListItem.js.map